import React from 'react';
import { StyledReactTooltip } from './tool-tip-components';
type Props = {
  id: string;
  text: string;
};
export default function ToolTip({ id, text }: Props) {
  return (
    <StyledReactTooltip id={id}>
      <div>{text}</div>
    </StyledReactTooltip>
  );
}
